export enum EWorkspaceStatus {
  ACTIVE = 0,
  ARCHIVED = 1
}
